export const SEARCH_SUGGESTION_DEBOUNCE_INTERVAL = 400;


// WEBPACK FOOTER //
// ./src/components/Search/search_const.js